// extracted by mini-css-extract-plugin
module.exports = {"header":"MicroCard_header__zFZ9f","wrapper":"MicroCard_wrapper__u0IOH","micro":"MicroCard_micro__IYnHR"};